import React, { useReducer, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'

import { PopoutMenu, PopoutDefaultHeader } from 'src/ui/PopoutMenu/PopoutMenu'
import { t } from 'src/lib/i18n-react'

import FilterButton from './subcomponents/FilterButton/FilterButton'
import Filter from './subcomponents/Filter/Filter'

const countFilters = (filters) => {
  return filters.reduce((acc, currentItem) => {
    if (currentItem.checked === true) {
      return acc + 1
    } else {
      return acc
    }
  }, 0)
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'CHECK':
      return {
        showPopout: true,
        filterCount: state.filterCount + 1,
        tutors: state.tutors.map((tutor) => {
          if (tutor.id == action.id) {
            return { ...tutor, checked: true }
          } else {
            return tutor
          }
        }),
        changed: true,
      }
    case 'UNCHECK':
      return {
        showPopout: true,
        filterCount: state.filterCount - 1,
        tutors: state.tutors.map((tutor) => {
          if (tutor.id == action.id) {
            return { ...tutor, checked: false }
          } else {
            return tutor
          }
        }),
        changed: true,
      }
    case 'RESET':
      return {
        showPopout: true,
        filterCount: 0,
        tutors: state.tutors.map((tutor) => {
          return { ...tutor, checked: false }
        }),
        changed: true,
      }
    case 'OPEN':
      return { ...state, showPopout: true }
    case 'CLOSE':
      return { ...state, showPopout: false }
    default:
      return state
  }
}

const TutorFilter = ({ filterProps, applyFilters }) => {
  const filterElement = useRef()
  const filterButtonRef = useRef()

  const initialState = {
    showPopout: false,
    filterCount: countFilters(filterProps),
    tutors: filterProps,
    changed: false,
  }

  const [state, dispatch] = useReducer(reducer, initialState)
  const label = t('Tutors')
  const accessibilityLabel = t(
    'tutors: %{smart_count} filter selected |||| %{smart_count} filters selected',
    {
      smart_count: state.filterCount,
    }
  )

  const handleToggleMenu = () => {
    dispatch({ type: state.showPopout ? 'CLOSE' : 'OPEN' })
  }

  const handleFilterChange = (type, tutorId) => {
    dispatch({ type: type ? 'CHECK' : 'UNCHECK', id: tutorId })
  }

  const handleReset = () => {
    dispatch({ type: 'RESET' })
    filterButtonRef.current.focus()
  }

  const handleApplyFilters = (event) => {
    //The filters are currently a form and the default
    //behaviour is to refresh the page on submit. We are preventing that here
    //if there is an event available
    if (event) {
      event.preventDefault()
    }

    dispatch({ type: 'CLOSE' })
    if (state.changed === true) applyFilters(state.tutors)
    filterButtonRef.current.focus()
  }

  useEffect(() => {
    if (state.showPopout === true) {
      document.body.classList.add('fixed')
    } else {
      document.body.classList.remove('fixed')
    }
    return () => {
      document.body.classList.remove('fixed')
    }
  }, [state.showPopout])

  return (
    <PopoutMenu
      popoutWidth="360px"
      show={state.showPopout}
      showCloseIcon={true}
      onClose={handleApplyFilters}
      closeAltText={t('Close and apply filters')}
      PopoutHeader={
        <PopoutDefaultHeader
          title={t('Available Tutors')}
          onClick={handleApplyFilters}
        />
      }
      PopoutButton={
        <FilterButton
          accessibilityLabel={accessibilityLabel}
          buttonRef={filterButtonRef}
          onClick={handleToggleMenu}
          label={label}
          filterCount={state.filterCount}
          showPopout={state.showPopout}
        />
      }
      PopoutBody={
        <Filter
          filterRef={filterElement}
          onFilterChange={handleFilterChange}
          onReset={handleReset}
          onApplyFilters={handleApplyFilters}
          tutors={state.tutors}
          checkedCount={state.filterCount}
        />
      }
    />
  )
}

TutorFilter.propTypes = {
  filterProps: PropTypes.array.isRequired,
  applyFilters: PropTypes.func.isRequired,
}

export default TutorFilter
